<template>
  <div class="page">
    <SecondaryCaseDialog
      v-model="open"
      :case-no="caseNo"
      mode="work"
      @reminder-read="$store.dispatch('refreshSecondaryBadges')"
      @changed="$store.dispatch('refreshSecondaryBadges')"
    />
  </div>
</template>

<script>
import SecondaryCaseDialog from '../../components/SecondaryCaseDialog.vue';

export default {
  name: 'SecondaryCaseDetailRoute',
  components: { SecondaryCaseDialog },
  data() {
    return { open: true };
  },
  computed: {
    caseNo() {
      return this.$route.params.caseNo;
    }
  },
  watch: {
    open(v) {
      if (!v) this.$router.replace('/secondary/pending');
    }
  }
};
</script>
